import React from 'react';
import {connect} from "react-redux";
//import PropTypes from "prop-types";
//import {featureInterface} from "../../../../../../../interfaces/featureInterface";
import {injectIntl} from "react-intl";
import {
  setSQFTActiveButton,
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  setSQFTSystemMessage
} from "../../../../../../../actions/sqftMenuFunctions";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import {SIDEBAR_HIDDEN_BUTTONS} from "../../../../../constants";
import {handleMiteredClick} from "../../../NavigationHelper";
import {getMiterEdgeFeature} from "../../../../../helpers/featureHelper";
import FeatureName from "../../../../../../visComponents/featureName";

const SqftNavEdgesMiteredButton = (props) => {
  const { selectedEdge, setSelectedEdge, setSQFTActiveSubMenuButton } = props;

  const edgeClick = (e) => {
    void e;
    setSelectedEdge(SIDEBAR_HIDDEN_BUTTONS.buttonMitered);
    setSQFTActiveSubMenuButton(SIDEBAR_HIDDEN_BUTTONS.buttonMitered);
    handleMiteredClick();
  };
  const miterEdgeFeature = getMiterEdgeFeature();

  return (
    <li className={"lightbox-option-round lightbox-option-round--edge " + ( selectedEdge === SIDEBAR_HIDDEN_BUTTONS.buttonMitered ? "lightbox-option-selected" : "" )}
        onClick={edgeClick}>
      <div className="lightbox-option-round-loader-edge lightbox-option-round-loader-edge--mitered"/>
      <div className="lightbox-description-text lightbox-description-text--edge">
        <FeatureName feature={miterEdgeFeature} maxLength={23}/>
      </div>
    </li>
  )
};

// SqftNavEdgesMiteredButton.propTypes = {
//   edgeFeature: PropTypes.shape(featureInterface)
// };

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTSystemMessage,
  updateSQFTCalculations,
  setSQFTActiveSubMenuButton,
  setSQFTActiveButton,
  setSQFTMenuOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavEdgesMiteredButton)
);
